import axios from 'common/utils/axios';
import { useMutation, useQuery, useSession } from 'common/hooks';
import type { TaggedEntity } from '../components/matching-engine-chat-interface.component';

const matchingEngineApi = axios('matching-engine');

export const useGetChatResponse = () => {
  const getChatResponse = (params: {
    chatId?: string;
    prompt: string;
    taggedEntities?: TaggedEntity[];
  }) => {
    return matchingEngineApi.get('chat-response', {
      params: {
        ...params,
        taggedEntities: params.taggedEntities?.length ? JSON.stringify(params.taggedEntities) : undefined,
      },
    });
  };

  const mutation = useMutation(getChatResponse, {
    showErrorSnackbar: false,
  });

  return {
    ...mutation,
    data: mutation.data?.data,
  };
};

export const useGetChat = () => {
  const getChat = (params: any) => {
    return matchingEngineApi.get(`chat`, { params });
  };

  const mutation = useMutation(getChat, {
    showErrorSnackbar: false,
  });

  return {
    ...mutation,
    data: mutation.data?.data,
  };
};

export const useGetChatHistory = () => {
  const { profile: loggedInUser } = useSession();
  const getChat = () => {
    return matchingEngineApi.get(`chat-history`);
  };

  const queryResponse = useQuery(
    ['matching-engine', 'chat-history', loggedInUser.id],
    getChat,
    {
      enabled: !!loggedInUser.id,
    },
  );

  return {
    ...queryResponse,
    data: queryResponse.data?.data,
  };
};
